<template>
  <div class="principal">
    <DependentInclusionRulesModal />
    <ListBoletoModal />
    <DemonstrativeAmountsPaidModal />
    <OtherSolicitationModal
      :title="this.solicitation"
      :requestData="this.request"
    />
    <CustomVisualizationLayout
      :leftInfoOne="leftInfoOne"
      :leftActionOne="this.leftActionOne"
      :leftInfoTwo="leftInfoTwo"
      :leftActionTwo="this.leftActionTwo"
    >
      <template slot="contentOne">
        <div class="card-health-plan">
          <div class="presentation">
            <p class="a1 mb-2 presentation-title">
              <b>Saiba mais sobre o plano de saúde dos Médicos Cooperados</b>
            </p>
            <p class="p3">
              O Plano de Saúde do Médico Cooperado possui abrangência Nacional
              (BR), acomodação em apartamento e não possui cobrança de
              coparticipação para o titular, respeitando sempre as regras e
              condições inerentes ao plano contratado, bem como as normas,
              regulamentações e legislações vigentes aplicáveis pela Agência
              Nacional de Saúde Suplementar.
            </p>
            <p class="p3">
              A qualquer momento, os cooperados podem solicitar a adesão ao
              Plano de Saúde do Médico Cooperado ou realizar a migração de um
              plano vigente.
            </p>
          </div>
          <div class="health-divider"></div>
          <HealthAccordion title="Mensalidade e Coparticipação">
            <template slot="content">
              <div class="health-plan-copart">
                <p class="health-plan-copart-title">Para titulares:</p>

                <ul>
                  <li>
                    <p>
                      Coparticipação: O plano não possui cobrança de
                      coparticipação para o titular e possui abrangência
                      nacional e apartamento;
                    </p>
                  </li>
                  <li>
                    <p>
                      <b>Mensalidade inicial: R$ 490,49;</b> valor sujeito aos
                      reajustes anuais definidos pela ANS;
                    </p>
                  </li>
                </ul>

                <p class="mt-2">
                  <span>Para dependentes:</span
                  >
                  Os valores dos dependentes seguem as condições previstas no
                  contrato vigente do plano e tabela de faixas etárias.
                </p>
              </div>
            </template>
          </HealthAccordion>

          <HealthAccordion title="Direitos e Deveres">
            <template slot="content">
              <div class="health-plan-rights-duties">
                <p class="health-plan-rights-duties-title">Direitos</p>
                <p>
                  Em atendimentos cobertos e realizados em caráter de urgência e
                  emergência ao médico cooperado titular e/ou seus dependentes,
                  em hospitais com tabela própria, os custos provenientes
                  poderão ser reembolsados de acordo com as tabelas de
                  remuneração e pagamento da rede prestadora da cooperativa, as
                  quais podem divergir dos valores praticados pelo hospital onde
                  ocorreu o atendimento.
                </p>
                <p class="health-plan-rights-duties-title">Deveres</p>
                <p>
                  Poderão perder o direito ao subsídio do Plano Médico Cooperado
                  os cooperados que não apresentarem produção mínima, conforme
                  previsto no Regimento Interno da Cooperativa.
                </p>
                <p>
                  <b>Além disso, o
                  Plano Médico Cooperado poderá ser automaticamente cancelado em
                  caso de inadimplência superior a 60 (sessenta) dias referente:</b>                                    
                </p>
                 <ul>
                    <li>Á parcela de responsabilidade do cooperado titular;</li>
                    <li>Ás mensalidades dos dependentes;</li>
                    <li>Ou demais valores financeiros vinculados ao plano.</li>
                  </ul> 
              </div>
            </template>
          </HealthAccordion>

          <HealthAccordion title="Como solicitar a adesão">
            <template slot="content">
              <div class="health-how-apply">
                <p class="health-how-apply-title">Recém-cooperados</p>
                <p>
                  Se você é um médico recém-cooperado e realizará a adesão de um
                  novo plano, sua solicitação deverá ser realizada pelo Portal
                  do Cooperado, mediante apresentação dos seguintes documentos:                  
                </p>
                  <ul>
                    <li>CPF e RG (documento oficial com foto);</li>
                    <li>Comprovante de residência emitido há menos de 90 dias.</li>
                  </ul> 
                <p>
                  Faça sua solicitação pelo botão de acesso rápido ao lado:
                  <b>Adesão e inclusão de dependentes</b>
                </p>
              </div>
            </template>
          </HealthAccordion>
          <HealthAccordion title="Inclusão de Dependentes">
            <template slot="content">
              <div class="health-dependents">
                <p class="health-dependents-title">
                  Inclusão e exclusão de dependentes para planos já ativos
                </p>
                <p>
                  Cooperados com plano ativo que possuam carteirinhas contendo
                  as iniciais abaixo:                      
                </p>
                  <ul>
                    <li>0025.8000</li>
                    <li>0025.1202</li>
                    <li>0025.1930</li>
                    <li>0025.1970</li>
                  </ul>
                <p class="mt-4">
                  Se desejarem incluir novos dependentes ou realizar exclusões
                  deverão <b>fazer a solicitação exclusivamente pelo App Cliente
                  UGF,</b> respeitando as regras contratuais do plano vigente.
                </p>
                <p>
                  Acesse o aplicativo em seu celular e <a target="_blank" href="https://www.unimed.coop.br/site/web/florianopolis/aplicativo-cliente-ugf">baixe o Aplicativo
                  Cliente UGF</a> 
                </p>
                <div class="health-dependents-divider"></div>
                <p class="health-dependents-title">
                  Quem pode ser incluído como dependente:
                </p>
                <p>
                <ul>
                  <li>Cônjuge ou companheiro(a), sem concorrência com cônjuge;</li>
                  <li>Filhos solteiros até 24 anos incompletos;</li>
                  <li>Enteados solteiros até 24 anos incompletos;</li>
                  <li>Netos solteiros até 24 anos incompletos;</li>
                  <li>Crianças ou adolescentes sob guarda, tutela ou
                  curatela do titular, mediante decisão judicial;</li>
                  <li>Pessoa sob
                  curatela do titular, mediante decisão judicial.</li>
                </ul>
                </p>
                <p class="health-dependents-title mb-2">
                  Documentos necessários para inclusão de dependentes
                </p>
                <p>
                  Documentos obrigatórios                     
                </p>
                  <ul>
                    <li>RG e CPF do titular;</li>
                    <li>RG e CPF do dependente.</li>
                  </ul>
                <p class="health-dependents-relationship">
                  Conforme o vínculo do dependente:
                </p>
                <p class="health-dependents-relationship-item">
                  Cônjuge
                </p>
                <p>
                  <ul>
                    <li>
                      Certidão de casamento civil.
                    </li>
                  </ul>
                </p>
                <p class="health-dependents-relationship-item">
                  Companheiro(a)
                </p>
                  <ul>
                    <li>Escritura pública de união
                  estável; ou</li>
                    <li>Declaração particular assinada pelos conviventes e
                  por duas testemunhas, com firmas reconhecidas em cartório.</li>
                  </ul>
                <p class="health-dependents-relationship-item">
                  Filho(a)
                </p>
                  <ul>
                    <li>Certidão de nascimento.</li>
                    <li>Caso o filho seja menor de 12
                  anos e possua reconhecimento de paternidade judicial ou
                  extrajudicial, também deverá ser apresentada a sentença ou
                  escritura pública de reconhecimento.</li>
                  </ul>
                <p class="health-dependents-relationship-item">Enteado(a)</p>
                  <ul>
                    <li>Certidão de
                  nascimento;</li>
                  <li>Documento comprobatório de convivência.</li>
                  </ul>
                <p class="health-dependents-relationship-item">Neto(a)</p>
                  <ul>
                    <li>Certidão de nascimento.</li>
                  </ul>
                <p class="health-dependents-relationship-item">
                  Pessoa sob guarda, tutela ou curatela
                </p>
                  <ul>
                    <li>Termo judicial de guarda, tutela ou curatela emitido pelo
                  Poder Judiciário.</li>
                  </ul>  
              </div>
            </template>
          </HealthAccordion>
        </div>
      </template>
      <template id="contentTwo" class="contentTwo" slot="contentTwo">
        <div class="quick-access-card">
          <div v-b-modal:list-boleto-modal class="links--internal">
            2ª via de boleto
          </div>
        </div>
        <div v-for="(solicitation, index) in getSolicitations" :key="index">
          <div
            class="quick-access-card"
            @click="onClickSubmitRequest(solicitation.id)"
          >
            <div class="links--internal">
              {{ solicitation.name }}
            </div>
          </div>
        </div>
        <div class="quick-access-card">
          <div
            v-b-modal:demonstrative-amounts-paid-modal
            class="links--internal"
          >
            Demonstrativo de valores pagos
          </div>
        </div>
        <div class="app-info-card">
          <p class="app-info-card-title">
            <img src="../../../assets/images/health-plan-client-app-icon.png" />
            <b class="ml-2">App Cliente UGF</b></p>
          <p class="app-info-card-sub-title">
            A gestão do seu plano de saúde deve ser realizada pelo App Cliente
            UGF.
          </p>
          <div class="app-info-card-content">
            <p>Onde, você encontra diversas funcionalidades em um só lugar:</p>
            <ul>
              <li>Autorizações;</li>
              <li>Reanálises;</li>
              <li>Solicitação de reembolso;</li>
              <li>Carteirinha virtual;</li>
              <li>Atualização cadastral;</li>
              <li>Agendamentos;</li>
              <li>Elogios, sugestões e reclamações;</li>
              <li>Canais de atendimento;</li>
              <li>Serviços financeiros;</li>
              <li>Solicitação de declarações;</li>
              <li>FAQs;</li>
              <li>Cancelamento;</li>
              <li>E muito mais.</li>
            </ul>
          </div>
        </div>
      </template>
    </CustomVisualizationLayout>
  </div>
</template>

<script>
import RoutesPaths from "../../../router/router-structure/routes-paths";
import CustomVisualizationLayout from "../components/visualization/CustomVisualizationLayout.vue";
import DependentInclusionRulesModal from "../views/DependentInclusionRulesModal.vue";

import ListBoletoModal from "../views/ListBoletoModal.vue";
import DemonstrativeAmountsPaidModal from "../views/DemonstrativeAmountsPaidModal.vue";
import { APP_WHATSAPP_CHAT_URL } from "../../../services/urls/enviroment-variables";
import { APP_CONTACT_PHONE_NUMBER } from "../../../services/urls/enviroment-variables";
import OtherSolicitationModal from "./OtherSolicitationModal.vue";
import JMJSolicitation from "../../../static-data/JMJSolicitation";
import HealthAccordion from "../components/visualization/HealthAccordion.vue";

import { formatFone } from "../../../utils/format/formtUtils";

const requestData = {
  category: null,
  subCategory: null,
  manifestation: null,
};

export default {
  computed: {
    getSolicitations() {
      return JMJSolicitation;
    },
    formattedContactPhone() {
      return formatFone(APP_CONTACT_PHONE_NUMBER);
    },
  },
  components: {
    CustomVisualizationLayout,
    DependentInclusionRulesModal,
    ListBoletoModal,
    DemonstrativeAmountsPaidModal,
    OtherSolicitationModal,
    HealthAccordion,
  },
  data: function () {
    return {
      leftActionOne: {
        text: "Plano de Saúde",
        onClick: this.leftActionClickHandler,
      },
      leftInfoOne: "",
      leftActionTwo: {
        text: "Acesso rápido",
        onClick: null,
      },
      leftInfoTwo: "",
      solicitation: "",
      request: {
        ...requestData,
      },
      tableItems: {
        title: "Saiba mais sobre o plano de saúde dos Médicos Cooperados",
      },
      tableFields: [
        {
          key: "title",
          label: "",
        },
      ],
    };
  },
  methods: {
    onClickSubmitRequest(typeId) {
      const configJMJ = JMJSolicitation.filter((item) => item.id == typeId)[0];
      if (configJMJ != null && configJMJ != undefined) {
        this.solicitation = configJMJ.name;
        this.request.category = configJMJ.category;
        this.request.subCategory = configJMJ.subCategory;
        this.request.manifestation = configJMJ.manifestation;
      }

      this.$bvModal.show("other-solicitation-modal");
    },
    leftActionClickHandler() {
      this.$router.push({
        path: RoutesPaths.benefit.rootName(),
        replace: true,
      });
    },
    onClickWhatzapp() {
      window.open(APP_WHATSAPP_CHAT_URL, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  font-size: 16px;
}

.card-health-plan {
  background-color: white;
  padding-top: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-bottom: 10px;
  border-radius: 7px;

  .presentation {
    margin-top: 10px;
  }

  .p3 {
    color: var(--dark-2);
    font-size: 14px;
  }
}

.health-divider {
  border-top: 1px solid #e5e5e5;
  margin-top: 24px;
  margin-bottom: 14px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.health-dependents-divider {
  border-top: 1px solid #C0DB6D;
  margin-top: 24px;
  margin-bottom: 14px;
  width: 90%;
  margin-left: auto;
  margin-right: auto;
}

.health-plan-copart,
.health-plan-rights-duties,
.health-how-apply,
.health-dependents {
  margin-left: 10px;
  margin-top: 5px;
  p {
    color: var(--dark-2);
    font-size: 14px;
  }

  ul {
    list-style-type: disc;
    padding-left: 15px;
    color: var(--dark-2);
    font-size: 14px;
  }
}

.health-plan-copart span,
p.health-plan-copart-title,
p.health-plan-rights-duties-title,
p.health-how-apply-title,
p.health-dependents-title {
  color: #00423e;
  font-weight: 500;
  font-size: 16px;
}

p.health-plan-rights-duties-title, p.health-how-apply-title,p.health-dependents-title {
  margin-top:20px;
}

p.health-plan-rights-duties-title, p.health-how-apply-title {
  margin-bottom:20px;
}

.presentation-title,
p.health-plan-copart-title,
.app-info-card-title {
  color: #00423e;
  font-weight: 500;
  font-size: 16px;
}

.health-plan-copart-title,
.app-info-card-title {
  font-size: 14px;
}

.presentation-title {
  font-size: 16px;
}

p.health-dependents-relationship {
  margin-top: 20px;
  margin-bottom: 5px;
  font-size: 16px;
}

.app-info-card-sub-title {
  color: var(--dark-2);
  font-size: 14px;
  font-weight: 600;
  margin-top: 10px;
}

.quick-access-card {
  border-radius: 5px;
  border: 1px solid #007a4a;
  background-color: white;
  font-size: 16px;
  padding: 5px 10px 5px 10px;
  color: #007a4a;
  margin-bottom: 10px;
}

.app-info-card {
  background-color: white;
  border-radius: 5px;
  font-size: 14px;
  padding-top: 10px;
  padding-left: 15px;
  padding-right: 15px;
  padding-bottom: 10px;
  b {
  font-size: 16px;
  }
  ul {
    list-style-type: disc;
  }
}

.app-info-card-content {
  p {
    font-size: 14px;
    color: #212529;
  }
}
</style>
<style>
.card-health-plan {
  .custom-accordion {
    padding-top: 10px;
    padding-left: 16px;
    padding-bottom: 10px;
    padding-right: 16px;
    margin-bottom: 15px;
  }

  div.card {
    border: 1px solid #dee2e6;
  }

  h3 {
    margin-left: 10px;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 0;
  }
}
</style>
